
  <!--
 * 横版
 * @LastEditTime: Mon Jan 06 2025 17:26:49 GMT+0800 (China Standard Time)
 -->
  <template>
  <div id="u_r_0J3316" :class="[curLang]" class="u_r_0J3316 route-index"  ><u_c_3AAA17></u_c_3AAA17><u_c_H25469></u_c_H25469><u_c_7NTW17></u_c_7NTW17><u_c_V3GG18></u_c_V3GG18><u_c_PU3219></u_c_PU3219><u_c_JDH534></u_c_JDH534><u_c_699X21></u_c_699X21></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Router from "@/hooks/router.js";
import { useRoute } from 'vue-router';
import bridge from "@/utils/sdkBridge.js";
import Language from "@/hooks/language.js";
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import u_c_3AAA17 from "@/components/u_c_3AAA17.vue";import u_c_H25469 from "@/components/u_c_H25469.vue";import u_c_7NTW17 from "@/components/u_c_7NTW17.vue";import u_c_V3GG18 from "@/components/u_c_V3GG18.vue";import u_c_PU3219 from "@/components/u_c_PU3219.vue";import u_c_JDH534 from "@/components/u_c_JDH534.vue";import u_c_699X21 from "@/components/u_c_699X21.vue"

    const { curLang, getLangTxt, langData } = Language();
    const compData = {};
    const ROUTER_DATA_LANG = {"zh-CN":{},"zh-TW":{},"en-US":{},"ja-JP":{},"ko-KR":{},"th-TH":{},"vi-VN":{},"de-DE":{},"fr-FR":{},"es-ES":{},"pt-PT":{},"it-IT":{},"tr-TR":{},"pl-PL":{},"id-ID":{},"ar-SA":{},"default":{}};
    const routerData = reactive(ROUTER_DATA_LANG[curLang] || ROUTER_DATA_LANG['en-US']||{});
    provide("routerData", routerData);
    const pageData = inject("pageData", {});
    const router = Router();
    const route = useRoute();
    let pagePlatform = "global"

    // 自定义setup - 开始
    const init = inject('init', () => {});

if (window.innerWidth < window.innerHeight && router.hasRoute('m')) {
  let routerCount = router.router.getRoutes().length;
  if (routerCount < 3) {
    init();
  } else {
    router.gotoRouter('/m');
  }
} else {
  init();
}
    // 自定义setup - 结束

  

</script>
<style lang="scss" scoped>

.zh-CN ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.zh-CN ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.zh-CN ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.zh-TW ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.zh-TW ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.zh-TW ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.en-US ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.en-US ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.en-US ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.ja-JP ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.ja-JP ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.ja-JP ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.ko-KR ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.ko-KR ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.ko-KR ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.th-TH ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.th-TH ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.th-TH ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.vi-VN ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.vi-VN ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.vi-VN ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.de-DE ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.de-DE ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.de-DE ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.fr-FR ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.fr-FR ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.fr-FR ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.es-ES ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.es-ES ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.es-ES ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.pt-PT ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.pt-PT ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.pt-PT ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.it-IT ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.it-IT ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.it-IT ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.tr-TR ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.tr-TR ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.tr-TR ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.pl-PL ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.pl-PL ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.pl-PL ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.id-ID ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.id-ID ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.id-ID ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.ar-SA ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.ar-SA ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.ar-SA ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.default ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.default ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.default ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
</style>
